import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  AccountCircleOutlined,
  DonutLargeOutlined,
  EmailOutlined,
  HttpOutlined,
  LocalPhoneOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetContractorDetailQuery } from "store/services/contractorApi";

import { useAuth } from "hooks/useAuth";

const ContractorInfoScreen = () => {
  const { viewEntity } = useAuth();

  const contractorId = viewEntity?.entity?.contractor?._id;

  const breadcrumbs = [
    {
      title: "Contractor Info",
    },
  ];

  // RTK Query
  const {
    data: contractorDetail,
    isLoading: loadingContractorDetail,
    error,
  } = useGetContractorDetailQuery(contractorId);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingContractorDetail}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingContractorDetail ? (
          <Box padding={3}>
            <Typography variant="h6">{contractorDetail?.name}</Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccountCircleOutlined color="primary" />}
                  title="Display Name"
                  subtitle={contractorDetail?.displayName}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <HttpOutlined color="primary" />}
                  title="Domain"
                  subtitle={contractorDetail?.domain}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <EmailOutlined color="primary" />}
                  title="Assistance Email"
                  subtitle={contractorDetail?.email}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalPhoneOutlined color="primary" />}
                  title="Assistance Phone"
                  subtitle={contractorDetail?.contactNumber}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DonutLargeOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={contractorDetail?.status === "Active"} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ContractorInfoScreen;
